module.exports = __webpack_public_path__ + "static/media/IGLogo.91a5e256.svg";